import { ListWithInfiniteScroll as List } from 'framework/list';
import RecruitingBoardContent from './RecruitingBoardContent';
import { MINUTE, useRecruitingBoardService } from 'domain/recruiting/recruitingBoard/shared';

const RecruitingBoard = () => {
  const { search } = useRecruitingBoardService();

  // TODO: Infinite Scroll (ListWithInfiniteScroll) / Virtualization
  // Use DataGridInfiniteScrollPagingHandler for handle scroll (See - ProjectsDashboardsDataGrid.tsx)
  return (
    <List
      getDataMethod={search}
      defaultSortOrder="DESC"
      defaultSortField="createdAt"
      defaultFilter={{ 'specification:vacancyGroupByStatus': { in: ['REQUIRES_REVIEW', 'OPEN'] } }}
      autoUpdateTime={MINUTE * 5}
    >
      <RecruitingBoardContent />
    </List>
  );
};

export default RecruitingBoard;
